import { PublicClientApplication } from "@azure/msal-browser";
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './App.css';
import { msalConfig } from './authentification/msalConfig';
import './components/ResponsiveEvent.jsx/Event.css';
import './index.css';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
const msalInstance = new PublicClientApplication(msalConfig);
await msalInstance.initialize();

root.render(
    <React.StrictMode>
        <App instance={msalInstance} />
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();